// extracted by mini-css-extract-plugin
export default {"title":"credit-card_title__ucwkR","row":"credit-card_row__FCobb"};